<ngx-app-bar
  class="w-100"
  [title]="'اخبار اقتصادی'"
  [rightButton]="{
    icon: 'arrow-right',
    style: 'neutral-link',
    mode: 'icon-only',
    size: 'medium',
  }"
  (onRightButtonClick)="onBackHandler()"
/>

<div class="news-container">
  @if (isLoading) {
    <app-spinner></app-spinner>
  } @else if (feed && feed.length) {
    <div class="news-content">
      <div
        class="news-card"
        *ngFor="let news of feed"
      >
        <app-news-card [data]="news"></app-news-card>
      </div>
    </div>
  } @else {
    <app-news-no-feed (onRetry)="loadFeed()"></app-news-no-feed>
  }
</div>
